/**
 * Ask the WebView to keep this bundle on the device (see `dev/offline-copy.ts` for the worker).
 *
 * Called after the player has started, never before: registering fetches `sw.js`, and nothing
 * between boot and first frame may wait on the network (invariant 7). A refusal — no service
 * worker support, an insecure origin, a 404 in a dev server — is logged and changes nothing about
 * playback; it only means the next boot without a network shows the shell's card instead of the
 * cached loop, which is the state this exists to end.
 */
export interface ServiceWorkerHost {
  readonly serviceWorker?: {
    register(url: string): Promise<unknown>;
  };
}

export async function keepOfflineCopy(
  host: ServiceWorkerHost,
  warn: (event: string, detail: Record<string, unknown>) => void,
): Promise<boolean> {
  if (host.serviceWorker === undefined) {
    warn('offline_copy.unsupported', {});
    return false;
  }
  try {
    await host.serviceWorker.register('./sw.js');
    return true;
  } catch (error) {
    warn('offline_copy.refused', { reason: error instanceof Error ? error.message : String(error) });
    return false;
  }
}
